import { createStyles }     from "@mantine/core";
import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => ( {
	feedWrapper: {
		height   : props?.activeUpdateTab === "announcements" ? "50vh" : "54vh", // 70vh without sub tabs, 64vh with sub tabs
		overflow : "hidden auto",

		[rooterMediaQuery.mobile]: {
			height: "calc(100vh - 200px)"
		}
	},
	content: {
		textAlign: "center"
	},
	svgIcon: {
		height       : "12rem",
		width        : "12rem",
		marginBottom : "1rem"
	},
	notificationEmptyText: {
		width        : "250px",
		overflowWrap : "break-word",
		wordBreak    : "break-word"
	}
} )
);

